module.exports = __webpack_public_path__ + "static/media/logo.b90bd6ea.png";